
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import {
  Form,
  FormItem,
  Input,
  Button,
  DatePicker,
  Upload,
  Select,
  Option,
  InputNumber,
  Row,
  Col,
} from 'element-ui';
import api from '@/api/match';
import moment from 'moment';

@Component({
  components: {
    Form,
    FormItem,
    Input,
    Button,
    DatePicker,
    Upload,
    Select,
    Option,
    InputNumber,
    Row,
    Col,
  },
})

export default class firstStep extends Vue {
  @Prop({
    required: true,
    default: false,
  }) oldForm!: any;

  @Prop({
    required: true,
    default: false,
  }) title!: any;

  private qualityList: { value: number; label: string; }[] = [{ value: 0, label: '私有' }, { value: 1, label: '公开' }];

  private manageList: { value: string; label: string; }[] = [];

  private fileListIcon: any = [];

  private fileListImg: any = [];

  public form: any = {
    title: '',
    sponsor: '',
    thumbnail: '',
    coverImage: '',
    content: '',
    quality: '',
    declarationTime: '',
    reviewTime: '',
    auditTime: '',
    endTime: '',
    manageTeacher: [],
    awardNumber: 0,
  }

  public loading: boolean = false;

  public $refs!: {
    form: Form,
  };

  private rules: any = {
    title: [
      { required: true, message: '请填写赛事名称', trigger: 'change' },
    ],
    sponsor: [
      { required: true, message: '请填写主办单位', trigger: 'change' },
    ],
    thumbnail: [
      { required: true, message: '请上传活动主图', trigger: 'change' },
    ],
    coverImage: [
      { required: true, message: '请上传缩略图', trigger: 'change' },
    ],
    quality: [
      { required: true, message: '请填写赛事性质', trigger: 'change' },
    ],
    declarationTime: [
      { required: true, message: '请填写申报时间', trigger: 'change' },
    ],
    reviewTime: [
      { required: true, message: '请填写评审时间', trigger: 'change' },
    ],
    auditTime: [
      { required: true, message: '请填写终审时间', trigger: 'change' },
    ],
    endTime: [
      { required: true, message: '请填写结束时间', trigger: 'change' },
    ],
    manageTeacher: [
      {
        type: 'array', required: true, message: '请填写管理员', trigger: 'blur',
      },
    ],
    awardNumber: [
      { required: true, message: '请填写获将人数', trigger: 'change' },
    ],
  };

  mounted() {
    api.getManage('').then((res: any) => {
      this.manageList = res.map((el: any) => ({ value: el.id, label: `${el.loginName}（${el.oName ? el.oName : ''}）` }));
    });
    if (this.title.includes('编辑')) {
      let form = {};
      form = {
        title: this.oldForm.title,
        sponsor: this.oldForm.sponsor,
        quality: this.oldForm.quality,
        declarationTime: this.oldForm.declarationTime,
        reviewTime: this.oldForm.reviewTime,
        auditTime: this.oldForm.auditTime,
        endTime: this.oldForm.endTime,
        organizer: this.oldForm.organizer,
        coOrganizer: this.oldForm.coOrganizer,
        awardNumber: this.oldForm.awardNumber,
        thumbnail: this.oldForm.thumbnail,
        coverImage: this.oldForm.coverImage,
        pid: this.oldForm.pid,
      };
      this.form = form as any;
      if (this.oldForm.manageTeacher && this.oldForm.manageTeacher.length) {
        this.form.manageTeacher = this.oldForm.manageTeacher;
      }
      this.fileListIcon = [{ url: this.oldForm.thumbnail }];
      this.fileListImg = [{ url: this.oldForm.coverImage }];
    }
  }


  /**
   * @author lianguongmou
   * @desc 图片上传前事件
    */
  handleBeforeUpload(file: File) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e:any) => {
      this.fileListImg = [{ url: e.target.result }];
    };
    this.form.thumbnail = file;
    return false;
  }

  /**
   * @author liangyongmou
   * @desc 主图片删除事件
   * @params { any } file 文件
   */
  handleBeforeRemove(file: any) {
    if (file.status === 'success') this.form.thumbnail = '';
  }

  /**
   * @author liangyongmou
   * @desc 管理员下拉框改变事件
   * @params { any } value 下拉框的值
   */
  handleSelectChange(value: any) {
    this.$forceUpdate();
    Vue.set(this.form, 'manageTeacher', value);
  }

  /**
   * @author liangyongmou
   * @desc 缩略图改变事件
   * @params { any } file 文件
   */
  handleIconBeforeRemove(file: any) {
    if (file.status === 'success') this.form.coverImage = '';
  }

  /**
   * @author lianguongmou
   * @desc 图片上传前事件
   */
  handleIconBeforeUpload(file: File) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e:any) => {
      this.fileListIcon = [{ url: e.target.result }];
    };
    this.form.coverImage = file;

    return false;
  }

  /**
   * @author liangyongmou
   * @desc 提交事件
   * @param 空
   */
  handleSubmit() {
    let result:any = {};
    this.$refs.form.validate((valid: boolean) => {
      if (valid) {
        result = this.form;
      }
    });
    return result;
  }
}
